import { styled, Theme } from '@mui/material';
import { display } from '@mui/system';
import { CoreDialogTitle, CoreDialogContent, CoreDialog, CoreTypography } from '@youscience/core';

export const sxStyles = {
  headSectionBg: (theme: Theme) => ({
    backgroundColor: theme.palette.common.white,
    overflow: 'hidden',
    borderTop: `1px solid ${theme.palette.grey['300']}`,
  }),
  headSectionInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    maxWidth: '634px',
    width: '100%',
  },
};

export const StyledDialogTitle = styled(CoreDialogTitle)(({ theme }) => ({
  ...theme.typography.h4,
  borderBottom: `1px solid ${theme.palette.grey['300']}`,

  [theme.breakpoints.up('sm')]: {
    padding: '1.75rem 3.5rem',
  },
}));

export const StyledDialogContent = styled(CoreDialogContent)(({ theme }) => ({
  maxHeight: '500px',
  padding: '0 1.5rem',

  [theme.breakpoints.up('sm')]: {
    padding: '0 2rem 0 3.5rem',
  },
}));

export const StyledCoreDialog = styled(CoreDialog)(() => ({
  '& .MuiDialog-container': {
    '& .MuiDialog-paper': {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflow: 'auto',
    },

    overflow: 'hidden',
  },
}));

export const StyledHeadSectionInner = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'end',
  maxWidth: '1320px',
  margin: '0 auto',
  position: 'relative',

  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    justifyContent: 'center',
  },
}));

export const StyledHeadSectionTitle = styled(CoreTypography)(({ theme }) => ({
  marginTop: '3.5rem',

  [theme.breakpoints.down('xs')]: {
    marginTop: '2rem',
  },
}));

export const StyledHeadSectionActions = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  marginTop: '3rem',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    marginTop: '2.75rem',
  },
}));

export const StyledSchoolPhotoWrap = styled('div')(({ theme }) => ({
  maxWidth: '850px',
  width: '100%',
  margin: '1.5rem auto 0 auto',
  textAlign: 'center',

  img: {
    position: 'static',
    display: 'block',
    margin: '0 auto',
    borderBottomLeftRadius: '240px',
    maxHeight: '480px',
    height: '100%',
  },

  [theme.breakpoints.up('lg')]: {
    width: '850px',
    margin: '0',

    img: {
      position: 'relative',
      left: '74px',
    },
  },

  [theme.breakpoints.up('xl')]: {
    img: {
      position: 'relative',
      left: '256px',
    },
  },
}));

export const StyledImgWrap = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    maxWidth: '527px',
    maxHeight: '340px',
    height: 'auto',
    width: 'auto',
  },
}));
